import React from "react";
import { Stack, IconButton, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export default function Qty({ value, onInc, onDec }) {
  const v = Math.max(0, Number(value) || 0);
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <IconButton
        size="small"
        onClick={() => onDec?.(Math.max(0, v - 1))}
        disabled={v <= 0}
        sx={{
          width: 36,
          height: 36,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "50%",
        }}>
        <RemoveIcon fontSize="small" />
      </IconButton>
      <Box sx={{ minWidth: 24, textAlign: "center", fontWeight: 700 }}>{v}</Box>
      <IconButton
        size="small"
        onClick={() => onInc?.(v + 1)}
        sx={{
          width: 36,
          height: 36,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "50%",
        }}>
        <AddIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}
